// extracted by mini-css-extract-plugin
export default {"container":"SnackBarTitle_container__0R7tv","title":"SnackBarTitle_title__WhATI","title--with-subtitle":"SnackBarTitle_title--with-subtitle__MR47F"};